
    module.exports = {
      render: function(){with(this){return _c('table',{staticClass:"validity-table"},[_c('tr',_l((scores),function(score){return _c('td',{staticClass:"validity-box"},[_c('score',{attrs:{"scoreObject":score,"score_band":score_band}})],1)}),0)])}},
      staticRenderFns: []
    };
  